<div class="position-relative h-100">
    <figure class="pl-1 pl-md-5 back-logo" *ngIf="!hasSessionActive">
        <img [src]="urlDefaultLogo" alt="">
    </figure>
    <app-track-guide-search *ngIf="!guide" (changeView)="changeView($event)" [hasSessionActive]="hasSessionActive">
    </app-track-guide-search>

    <app-track-guide-detail *ngIf="guide" [guide]="guide">
    </app-track-guide-detail>
</div>